import { responseError } from '@/utils/errors';
import findResult, {
  assignIfExists,
  isValidFilter,
  selectableResult,
  assignProps,
  removeItemByMemberID,
  findItemByMemberID,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { findAllSearches, findSearch, findSearchMembers } from '../../state/state';
import actions, { searchPermissionGroups } from '../constants';
import sharingSearch, {
  searchMembers,
  newSearchMember,
  searchPermsFromArray,
} from './state';

const hideShareSearch = withDraft((draft, action) => {
  const item = findSearch(draft, action);
  draft.sharingSearch = sharingSearch();
  item.members = searchMembers(10000);
  item.unassignedMembers = searchMembers(20, 3, true);
});

const showShareSearch = withDraft((draft, action) => {
  const item = findSearch(draft, action);
  draft.sharingSearch.open = true;
  draft.sharingSearch.category = action.category;
  draft.sharingSearch.code = action.code;
  item.members = searchMembers(10000);
  item.unassignedMembers = searchMembers(20, 3, true);
});

const updateSearchMemberProperties = withDraft((draft, action) => {
  const members = findSearchMembers(draft, action);
  assignProps(members, action.properties);
});

const fetchSearchMembers = withDraft((draft, action) => {
  const members = findSearchMembers(draft, action);
  members.filter = action.filter;
  members.results = [];
  members.readStatus = isValidFilter(action.filter, members) ? states.PENDING : states.NONE;
});

const showSearchMembers = withDraft((draft, action) => {
  const members = findSearchMembers(draft, action);
  const results = action.results.map(selectableResult);
  members.readStatus = states.SUCCESS;
  members.readErrors = [];
  members.results = results;
  members.original = results;
  members.count = action.resultsCount;
});

const showSearchMembersError = withDraft((draft, action) => {
  const members = findSearchMembers(draft, action);
  members.readStatus = states.ERROR;
  members.readErrors = [responseError(action)];
});

const addSearchMembers = withDraft((draft, action) => {
  const item = findSearch(draft, action);
  const perms = searchPermsFromArray(searchPermissionGroups[draft.sharingSearch.permissionGroup]);
  const membersToAdd = draft.sharingSearch.membersToAdd.map((member) => newSearchMember(member, perms));
  draft.sharingSearch.membersToAdd = [];
  item.members.results = item.members.results.concat(membersToAdd);
  item.unassignedMembers.filter = '';
});

const removeSearchMember = withDraft((draft, { category, code, memberID }) => {
  const item = findSearch(draft, { category, code });
  item.members.results = removeItemByMemberID(item.members.results, memberID);
});

const updateSearchMemberPermissions = withDraft((draft, {
  category, code, memberID, permissions,
}) => {
  const item = findSearch(draft, { category, code });
  const member = findItemByMemberID(item.members.results, memberID);
  member.permissions = searchPermsFromArray(searchPermissionGroups[permissions]);
});

const shareSearchSuccessOrError = withDraft((draft) => { draft.sharingSearch = sharingSearch(); });

const updateCurrentSearchPermissions = withDraft((draft, { code, permissions }) => {
  findAllSearches(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.searches, category, code);
    item.permissions = permissions;
  });
});

const updateShareSearchProperties = withDraft((draft, action) => {
  assignIfExists(draft.sharingSearch, action.properties);
});

const shareSearch = withDraft((draft) => { draft.sharingSearch.updateStatus = states.PENDING; });

export default {
  [actions.ADD_SEARCH_MEMBERS]: addSearchMembers,
  [actions.FETCH_SEARCH_MEMBERS]: fetchSearchMembers,
  [actions.HIDE_SHARE_SEARCH]: hideShareSearch,
  [actions.REMOVE_SEARCH_MEMBER]: removeSearchMember,
  [actions.SHARE_SEARCH]: shareSearch,
  [actions.SHARE_SEARCH_ERROR]: shareSearchSuccessOrError,
  [actions.SHARE_SEARCH_SUCCESS]: shareSearchSuccessOrError,
  [actions.SHOW_SEARCH_MEMBERS]: showSearchMembers,
  [actions.SHOW_SEARCH_MEMBERS_ERROR]: showSearchMembersError,
  [actions.SHOW_SHARE_SEARCH]: showShareSearch,
  [actions.UPDATE_CURRENT_SEARCH_PERMISSIONS]: updateCurrentSearchPermissions,
  [actions.UPDATE_SEARCH_MEMBER_PERMISSIONS]: updateSearchMemberPermissions,
  [actions.UPDATE_SEARCH_MEMBER_PROPERTIES]: updateSearchMemberProperties,
  [actions.UPDATE_SHARE_SEARCH_PROPERTIES]: updateShareSearchProperties,
};
